const defaultState = {}

const modals = (state = defaultState, action) => {
  switch (action.type) {
    case 'MODALS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default modals



// WEBPACK FOOTER //
// ./src/reducers/modals.js